<template>
    <footer class="bg-white">
        <div class="mx-auto max-w-7xl overflow-hidden py-20 px-6 sm:py-24 lg:px-8">
            <nav class="-mb-6 columns-2 sm:flex sm:justify-center sm:space-x-12" aria-label="Footer">
                <div v-for="item in navigation.main" :key="item.name" class="pb-6">
                    <component
                        :is="item.type" :href="item.href"
                        class="text-sm leading-6 text-gray-600 hover:text-gray-900">{{
                            item.name
                        }}
                    </component>
                </div>
            </nav>
            <div class="mt-10 flex justify-center space-x-10">
                <a
                    v-for="item in navigation.social" :key="item.name" :href="item.href"
                    class="text-gray-400 hover:text-gray-500">
                    <span class="sr-only">{{ item.name }}</span>
                    <component :is="item.icon" class="h-6 w-6" aria-hidden="true"/>
                </a>
            </div>
            <p class="mt-10 text-center text-xs leading-5 text-gray-500">&copy; {{ new Date().getFullYear() }} Landscape
                Ventures Ltd. All rights
                reserved.</p>
        </div>
    </footer>
</template>

<script>
import {defineComponent, h} from 'vue';
import {Link} from '@inertiajs/vue3';

export default {
    components: {
        Link
    },
    data() {
        return {
            navigation: {
                main: [
                    {name: 'VC Reviews', href: this.route('reviews.latest'), type: 'Link'},
                    {
                        name: 'Dealflow Intelligence',
                        href: '#',
                        type: 'Link',
                    },
                    {name: 'Syndicate', href: '#', type: 'Link'},
                    {name: 'Blog', href: 'https://www.landscape.vc/blog', type: 'a'},
                    {name: 'Terms of Use', href: this.route('terms.show'), type: 'a'},
                    {name: 'Privacy Policy', href: this.route('policy.show'), type: 'a'},
                ],
                social: [
                    {
                        name: 'Twitter',
                        href: 'https://twitter.com/Landscape_vc',
                        icon: defineComponent({
                            render: () =>
                                h('svg', {fill: 'currentColor', viewBox: '0 0 24 24'}, [
                                    h('path', {
                                        d: 'M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84',
                                    }),
                                ]),
                        }),
                    },
                    {
                        name: 'LinkedIn',
                        href: 'https://uk.linkedin.com/company/landscapevc',
                        icon: defineComponent({
                            render: () =>
                                h('svg', {
                                    fill: 'currentColor',
                                    viewBox: '0 0 24 24',
                                }, [
                                    h('path', {
                                        'fill-rule': 'evenodd',
                                        'clip-rule': 'evenodd',
                                        d: 'M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z',
                                    }),
                                ]),
                        }),
                    }
                ],
            }
        };
    }
};
</script>
